import { useAppState } from '@/context/AppStateContext';
import { getOrderTypeCardStyle, MoldOrder } from '../../types/mold';

const MoldOrderCardTypeLabel = ({ moldOrder }: { moldOrder: MoldOrder }) => {
    const { getMoldOrderTypeLabel } = useAppState();
    return (
        <div className="flex justify-start items-center text-xs">
            <span className={`${getOrderTypeCardStyle(moldOrder.type)} py-1 px-2 rounded-lg`}>{getMoldOrderTypeLabel(moldOrder.type)}</span>
        </div>
    )
}

export default MoldOrderCardTypeLabel;
